import type {
  ShippingOption,
  ShippingOptionInput,
} from "schemas/shippingOption";
import type { RequestFn } from "./request";

export function createShippingOptionsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    get: ({ projectId }: { projectId: string }) => {
      return request<{ options: ShippingOption[] }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/shipping-options`,
      });
    },
    replace: ({
      projectId,
      options,
    }: {
      projectId: string;
      options: ShippingOptionInput[];
    }) => {
      return request<{ options: ShippingOption[] }>({
        method: "PUT",
        path: `/api/v1/projects/${projectId}/shipping-options`,
        body: { options },
      });
    },
  };
}
